import React, {useState,useEffect} from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { verifiEmail } from '../../Service';
import '../css/LoginStyle.css';

export default function EmailVerification() {
    let params = useParams();
    const navigation = useNavigate();
    

    useEffect(() => {
        let actcode=params.actcode;
        let email=params.email;
        let paramsDT={actcode:actcode,email:email};
        verifiEmail(paramsDT).then(res => handleResponse(res))
    }, []);
    
    const handleResponse = (response) => {

        if (response.data.code == 200) {
            Swal.fire({
                icon: 'success',
                title: 'Verification',
                text: response.data.message,
            })
            setTimeout(() => {
                navigation('/login')
              }, 3000)
        } else {
            let errors = {};
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: response.data.message,
            })
            navigation("/login");
        }
    }
    
    return(
        <>
        <section className="sec-container" >

<div className='container'>

    <div className='thankyou'>

        <div className='row'>

            <div className='col-md-12'>

                    <h1>Hi</h1>

                    <p>Your Account has been verified. You can login and proceed further</p>

            </div>

        </div>

    </div>

</div>

</section>
        </>
    )
}